var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader-wrap",style:({position: _vm.position})},[_c('div',[_c('div',{staticClass:"loader"}),_c('p',{staticClass:"u-mb0"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }